<template>
	<page-layout class="contacts-page" title="Kontakter">
		<table-view :columns="columns" :items="items" @item="itemClick" />
	</page-layout>
</template>

<script>
	import PageLayout from '@/app/layouts/PageLayout'
	import SelectPopupView from '@/components/SelectPopupView'

	export default {
		components: {
			pageLayout: PageLayout
		},
		data() {
			return {
				columns: [
					{
						data: ['name'],
						label: 'Navn'
					}
				],
				items: [
			
				]
			};
		},
		methods: {
			create() {
				var self = this;

			},
			itemClick(item) {
				var self = this;
				var options = [];

				if (item.phone) {
					options.push({
						label: 'Telefon',
						value: item.phone,
						callback: function () {
							window.location = 'tel:' + item.phone;
							self.$store.commit('popPopup');
						}
					});
				}

				if (item.email) {
					options.push({
						label: 'E-mail',
						value: item.email,
						callback: function () {
							window.location = 'mailto:' + item.email;
							self.$store.commit('popPopup');
						}
					});
				}

				this.$store.commit('pushPopup', {
					component: SelectPopupView,
					props: {
						title: item.name,
						options: options,
						actions: [
							{
								label: 'Annuller',
								callback() {
									self.$store.commit('popPopup');
								}
							}
						]
					}
				});
			},
			itemDelete(item) {
				var self = this;

				this.axios.delete('/portal/users/' + item.id + '/').then(function () {
					self.update();
				});
			},
			update() {
				var self = this;

				this.axios.get('/employees/active/').then(function (r) {
					self.items = r.data._items;
				});
			}
		},
		mounted() {
			this.update();
		}
	}
</script>

<style lang="scss" scoped>
	.contacts-page {

	}
</style>